<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :visible.sync="visible"
    :show-close="true"
    :subject="subject"
    :subtitle="subtitle"
    :theme="theme"
    showFooter
    destroy-on-close
    append-to-body
    width="20%"
    @on-confirm="close"
  ></tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  data() {
    return {
      visible: false,
    };
  },
  props: {
    blocked: Number,
    username: String,
    isAll: Boolean,
    action: String,
  },
  computed: {
    subject() {
      return this.$t("enum.member.freeze_account");
    },
    subtitle() {
      return this.$t("enum.member.can_not_change");
    },
    theme() {
      return "warning";
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>